import React from "react";
import { FormikSwitchInput } from "src/components/Inputs/FormikSwitchInput";
import { z } from "zod";
import { useLiveEditConfirmation } from "../../LiveEditConfirmation";
import * as QuestionType from "./QuestionType";

export const FormikSchema = z
  .object({
    requirement: z.union([z.literal("Required"), z.literal("NotRequired")]),
  })
  .and(QuestionType.FormikSchema);
export type FormikType = z.infer<typeof FormikSchema>;

type Props = {
  questionId: uuid;
};
export const RequirementSwitch: React.FC<Props> = ({ questionId }) => {
  const LiveEditConfirmation = useLiveEditConfirmation();

  const id = `requirement-${questionId}`;
  return (
    <FormikSwitchInput<FormikType["requirement"]>
      id={id}
      name="requirement"
      label="Required"
      direction="row"
      checked={["Required", ""]}
      unchecked={["NotRequired", ""]}
      beforeChange={async ({ nextValue }) => {
        if (nextValue === "NotRequired") {
          return true;
        }

        return await LiveEditConfirmation.confirmRequirement();
      }}
    />
  );
};
